/* eslint-disable no-unused-vars */
/* !

=========================================================
* Material Dashboard React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import React from 'react';

// core components/views for Admin layout

import RootRoutes from './views/routes';
import ProjectRoutes from '~/routes/projectMg.routes';

import UserRoutes from '~/routes/user.routes'
import CRMRoutes from '~/routes/crm.routes'
import CashFlowRoutes from '~/routes/cashFlow.routes';

const rootRoutes = [
  ...ProjectRoutes,
  ...CRMRoutes,
  ...CashFlowRoutes,
  ...RootRoutes,
  ...UserRoutes,

];

export default rootRoutes;
